import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import EmptySearchImage from 'app/assets/empty-search.svg?react';

type EmptyStateProps = {
  title?: string;
  subtitle?: string;
  link?: {
    label: string;
    href: string;
    replace?: boolean;
  };
};

export default function EmptyState({
  title = 'No results were found to your search',
  subtitle = 'Try modifying your search request',
  link,
}: EmptyStateProps) {
  return (
    <Box className="my-24 flex flex-col text-center items-center gap-6">
      <EmptySearchImage />
      <Typography className="font-500 text-14 text-typography-secondary">{title}</Typography>
      {subtitle && (
        <Typography className="font-400 text-12 text-typography-thirty">{subtitle}</Typography>
      )}
      {link && (
        <Link to={link.href} replace={link.replace ?? false}>
          {link.label}
        </Link>
      )}
    </Box>
  );
}
